import { MouseEventHandler } from 'react';

import TrashIcon from 'packages/kakapo-ui-kit/assets/icons/TrashIcon';
import CircleButton from 'packages/kakapo-ui-kit/components/editors/CircleButton';

interface IProps {
	onClick: MouseEventHandler<HTMLElement>;
	size?: number;
}

export default function DeleteButton({ onClick, size = 28 }: IProps) {
	return (
		<CircleButton color="danger" hoverColor="dangerDark" size={size} onClick={onClick}>
			<TrashIcon color="white" />
		</CircleButton>
	);
}
